
import * as ipxRuntime$_5exlnksoQnuOJfdn8oTsecWJWJehxDVhvVhUQSHICUY from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@9.1.2_db0@0.3.2_bette_935111ed3e58ee2a615fb43b34b4244e/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$g1oP9nFmsPJLnXxvhTz8YoNYkQgNHOwr6tuJuFvJn5M from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_@netlify+blobs@9.1.2_db0@0.3.2_bette_935111ed3e58ee2a615fb43b34b4244e/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_5exlnksoQnuOJfdn8oTsecWJWJehxDVhvVhUQSHICUY, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$g1oP9nFmsPJLnXxvhTz8YoNYkQgNHOwr6tuJuFvJn5M, defaults: {} }
}
        